<template>
  <div>
    <v-content>
      <v-container>
        <h1 class="display-3 secondary--text font-weight-bold pl-4 pt-2">
          Search results for {{ $route.params.searchTerm }}
        </h1>
        <v-container grid-list-xl fluid>
          <v-layout column>
            <v-flex v-for="listing in searchResults" :key="listing.id">
              <fma-tile
                :title="listing.title"
                :description="listing.description"
                :action-on-tile-click="() => openDialog(listing)"
                line-clamp
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-container>
      <v-dialog
        v-model="dialogOpen"
        width="75vw"
        content-class="overflow-visible"
      >
        <v-card max-height="75vh">
          <v-card max-height="75vh" style="overflow: auto;">
            <fma-listing :listing="currentDialogData" />
          </v-card>
          <v-btn
            id="close-button"
            icon
            color="primary"
            class="ma-0 fma-round-button"
            @click="dialogOpen = false"
          >
            <v-icon x-large>
              close
            </v-icon>
          </v-btn>
        </v-card>
      </v-dialog>
    </v-content>
  </div>
</template>

<script>
import FmaTile from "@/components/FmaTile.vue";
import FmaListing from "@/components/FmaListing.vue";

export default {
  components: {
    FmaTile,
    FmaListing
  },
  data() {
    return {
      currentDialogData: {},
      dialogOpen: false
    };
  },
  computed: {
    searchResults() {
      return this.$store.state.searchResults;
    }
  },
  mounted() {
    this.$store.dispatch("fetchSearchResults", {
      searchTerm: this.$route.params.searchTerm
    });
  },
  methods: {
    openDialog(listing) {
      // update the dialog content to correspond to the tile that was opened
      this.$data.currentDialogData = listing;
      // display the dialog
      this.$data.dialogOpen = true;
    }
  }
};
</script>

<style scoped lang="less">
@import "../assets/global.less";

@close-button-radius: 32px;

#close-button {
  position: absolute;
  top: -@close-button-radius;
  right: -@close-button-radius;
  height: 2 * @close-button-radius;
  width: 2 * @close-button-radius;
}
</style>
